import { useState } from 'react';
import * as St from './index.styled';
import { CustomDialog } from '../../../../../components/dialog/v1/CustomDialog';
import CustomBlockButton from '../../../../../components/button/CustomBlockButton';

// 동일 품목(상품명 + 옵션명) 일괄 선택 모달.
// 파레트 준비 탭 / 제품리스트 탭에서 공용으로 사용한다.
// selectableCount = 아직 선택되지 않은 동일 품목 수 (= 이번에 추가로 선택 가능한 최대치)
export function WegetBulkSelectModal({
    open,
    onClose,
    productName,
    optionName,
    totalCount,
    selectedCount,
    selectableCount,
    onConfirm
}) {
    const [quantity, setQuantity] = useState(selectableCount);
    // 터치 환경에서 자동 포커스하면 모달이 열리자마자 키패드가 올라와 버튼들을 가린다.
    // 마우스 환경(pointer: fine)에서만 자동 포커스한다.
    const [autoFocusEnabled] = useState(() => {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
            return false;
        }
        return window.matchMedia('(pointer: fine)').matches;
    });

    const clamp = (number) => Math.max(0, Math.min(selectableCount, number));

    const handleChangeQuantity = (e) => {
        const value = e.target.value;
        if (value === '') {
            setQuantity('');
            return;
        }

        const parsed = Number(String(value).replace(/[^0-9]/g, ''));
        if (isNaN(parsed)) {
            return;
        }
        setQuantity(clamp(parsed));
    }

    const handleAddQuantity = (amount) => {
        setQuantity(prev => clamp((Number(prev) || 0) + amount));
    }

    const handleConfirm = () => {
        const count = clamp(Number(quantity) || 0);
        if (count <= 0) {
            return;
        }
        onConfirm(count);
    }

    const isConfirmable = clamp(Number(quantity) || 0) > 0;

    return (
        <CustomDialog open={open} onClose={() => onClose()}>
            <St.Header>
                <CustomDialog.Header>
                    <CustomDialog.Header.Fake />
                    <CustomDialog.Header.Title>동일 품목 일괄 선택</CustomDialog.Header.Title>
                    <CustomDialog.Header.Close onClick={() => onClose()} />
                </CustomDialog.Header>
            </St.Header>
            <St.Body>
                <div className='product'>
                    <div className='name'>{productName}</div>
                    <div className='option'>{optionName}</div>
                </div>

                <div className='summary'>
                    <span>전체 <b>{totalCount}</b></span>
                    <span>이미 선택 <b>{selectedCount}</b></span>
                    <span className='max'>선택 가능 <b>{selectableCount}</b></span>
                </div>

                <div className='guide'>최대 {selectableCount}개까지 선택할 수 있습니다.</div>

                <div className='inputRow'>
                    <input
                        type='number'
                        inputMode='numeric'
                        value={quantity}
                        onChange={handleChangeQuantity}
                        onFocus={(e) => e.target.select()}
                        autoFocus={autoFocusEnabled}
                    />
                    <span className='unit'>개</span>
                </div>

                <div className='quickRow'>
                    <button type='button' onClick={() => handleAddQuantity(1)}>+1</button>
                    <button type='button' onClick={() => handleAddQuantity(5)}>+5</button>
                    <button type='button' onClick={() => handleAddQuantity(10)}>+10</button>
                    <button type='button' className='max' onClick={() => setQuantity(selectableCount)}>최대</button>
                    <button type='button' className='reset' onClick={() => setQuantity(0)}>초기화</button>
                </div>

                <div className='actions'>
                    <CustomBlockButton
                        type='button'
                        className='cancel'
                        onClick={() => onClose()}
                    >
                        취소
                    </CustomBlockButton>
                    <CustomBlockButton
                        type='button'
                        className='confirm'
                        disabled={!isConfirmable}
                        onClick={() => handleConfirm()}
                    >
                        확인
                    </CustomBlockButton>
                </div>
            </St.Body>
        </CustomDialog>
    );
}
